import React from 'react';
import { DateRange } from 'react-day-picker';
import { StudyDateRangeFilter, SingleDateFilter as SingleDatePicker } from './columnFilters';
import { FilterWrapper } from './filterWrapper';

interface DateFilterProps {
  column: any;
}

interface SingleDateColumnFilterProps {
  column: any;
  placeholder?: string;
}

/** Single calendar date + clear affordance, wired to a TanStack column filter (e.g. UploadDate). */
export const SingleDateColumnFilter: React.FC<SingleDateColumnFilterProps> = ({
  column,
  placeholder,
}) => {
  const filterValue = column.getFilterValue() as Date | undefined;

  return (
    <FilterWrapper
      filterValue={filterValue}
      onClear={() => column.setFilterValue(undefined)}
      className="w-4/4"
    >
      <SingleDatePicker
        value={filterValue}
        onChange={(date) => column.setFilterValue(date)}
        placeholder={placeholder}
      />
    </FilterWrapper>
  );
};

export const DateFilter: React.FC<DateFilterProps> = ({ column }) => {
  const filterValue = column.getFilterValue();

  const dateRange = React.useMemo(() => {
    if (Array.isArray(filterValue)) {
      return {
        from: filterValue[0],
        to: filterValue[1],
      };
    }
    return filterValue as DateRange | undefined;
  }, [filterValue]);

  return (
    <FilterWrapper
      filterValue={filterValue}
      onClear={() => column.setFilterValue(undefined)}
      className="w-4/4"
    >
      <StudyDateRangeFilter
        value={dateRange}
        onChange={(range) => column.setFilterValue(range)}
      />
    </FilterWrapper>
  );
};
